import type { AcaoDoCiclo, InviteStatus, PropostaStatus } from "@/types/finance";

/** Passos que a equipe pode marcar em cada status; o primeiro é o próximo natural. Espelha lifecycle.py da API. */
const PASSOS_DA_PROPOSTA: Record<PropostaStatus, AcaoDoCiclo[]> = {
  rascunho: [],
  gerada: ["enviado", "aceito", "recusado"],
  enviada: ["aceito", "recusado", "reaberto"],
  aceita: ["reaberto"],
  lancada_omie: [],
  recusada: ["reaberto"],
  cancelada: [],
};

const PASSOS_DO_INVITE: Record<InviteStatus, AcaoDoCiclo[]> = {
  gerado: ["enviado", "aceito", "recusado"],
  enviado: ["aceito", "recusado", "reaberto"],
  aceito: ["reaberto"],
  recusado: ["reaberto"],
  cancelado: [],
};

export const INVITE_STATUS_INFO: Record<InviteStatus, { label: string; badgeClass: string }> = {
  gerado: { label: "Gerado", badgeClass: "border-blue-200 bg-blue-50 text-blue-700" },
  enviado: { label: "Enviado", badgeClass: "border-purple-200 bg-purple-50 text-purple-700" },
  aceito: { label: "Aceito", badgeClass: "border-emerald-200 bg-emerald-50 text-emerald-700" },
  recusado: { label: "Recusado", badgeClass: "border-red-200 bg-red-50 text-red-700" },
  cancelado: { label: "Cancelado", badgeClass: "border-slate-200 bg-slate-100 text-slate-500" },
};

export function passosDaProposta(status: PropostaStatus): AcaoDoCiclo[] {
  return PASSOS_DA_PROPOSTA[status] ?? [];
}

export function passosDoInvite(status: InviteStatus): AcaoDoCiclo[] {
  return PASSOS_DO_INVITE[status] ?? [];
}

